import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#0B2146" />
    <path d="M18 19h28L24 45h22" fill="none" stroke="#fff" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="48" cy="18" r="5" fill="#35C5F4" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo-link" aria-label="ZOHFRY home">
    <LogoMark />
    <span className={`text-xl font-bold tracking-tight ${light ? "text-white" : "text-navy"}`}>
      ZOHFRY<span className="text-cyan">.</span>
    </span>
  </Link>
);
